import React from 'react'

type Props = {}

const Separator = (props: Props) => {
  return (
    <div className='section-separator'>
    </div>
  )
}

export default Separator